import {Component, EventEmitter, OnInit, Input, Output, OnChanges, SimpleChanges} from '@angular/core';
import {MatSelectChange} from '@angular/material/select';

export interface RefreshInterval {
    name: string;
    interval: number; // in milliseconds
}

const REFRESH_INTERVALS: RefreshInterval[] = [
    {
        name: '5s',
        interval: 5000
    },
    {
        name: '10s',
        interval: 10000
    },
    {
        name: '30s',
        interval: 30000
    },
    {
        name: '1m',
        interval: 60000
    },
    {
        name: '5m',
        interval: 300000
    },
    {
        name: '15m',
        interval: 900000
    },
    {
        name: '30m',
        interval: 1800000
    },
    {
        name: '1h',
        interval: 3600000
    },
    {
        name: '2h',
        interval: 7200000
    },
    {
        name: '1d',
        interval: 86400000
    }
];

@Component({
    selector: 'app-periodic-refresh',
    templateUrl: './periodic-refresh.component.html',
    styleUrls: ['./periodic-refresh.component.scss']
})
export class PeriodicRefreshComponent implements OnInit, OnChanges {

    private timer: NodeJS.Timeout;

    @Input() refreshIntervalName: string;
    @Output() refreshIntervalChange: EventEmitter<RefreshInterval> = new EventEmitter<RefreshInterval>();
    @Output() refreshTrigger: EventEmitter<void> = new EventEmitter<void>();
    @Output() intervalResetter: EventEmitter<() => void> = new EventEmitter<() => void>();

    refreshInterval: RefreshInterval;
    refreshIntervals: RefreshInterval[];

    constructor() {
        this.refreshIntervals = REFRESH_INTERVALS;
        this.timer = null;
    }

    ngOnInit() {
        this.refreshInterval = this.refreshIntervals.find(int => int.name === this.refreshIntervalName) || null;
        this.refreshIntervalChange.emit(this.refreshInterval);
        this.intervalResetter.emit(() => this.setupInterval());
        this.setupInterval();
    }

    ngOnChanges(changes: SimpleChanges) {
        if ('refreshIntervalName' in changes && !changes.refreshIntervalName.isFirstChange()) {
            this.refreshInterval = this.refreshIntervals.find(int => int.name === changes.refreshIntervalName.currentValue) || null;
            this.refreshIntervalChange.emit(this.refreshInterval);
            this.setupInterval();
        }
    }

    trackByIndex(index: number, _: RefreshInterval): number {
        return index;
    }

    onSelectRefreshInterval(_: MatSelectChange) {
        this.setupInterval();
    }

    private setupInterval() {
        if (this.timer) {
            clearInterval(this.timer);
        }
        this.timer = this.refreshInterval ?
            setInterval(() => this.refreshTrigger.next(), this.refreshInterval.interval) :
            null;
    }
}
